var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGschoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.3,4.8C5.8,5.2,6.6,8.2,8.5,7.9C9.9,7.5,9,4.4,7.3,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1,11.7c0,0.8,1.2,1.2,2.5,0.9c1.6-0.5,1.6-2-0.3-2.4C7.2,10.2,6.1,10.9,6.1,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,0H3C1.3,0,0,1.3,0,3v10c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3V3C16,1.3,14.7,0,13,0z M11.9,5v3.2 c0,0.3-0.7,0.4-0.7,0V5c0-0.1,0.1-0.2,0.2-0.3l0-0.5L10,5.4c0.1,0.5,0.3,0.8,0.2,1.3C10.1,7.5,9.4,7.8,9,8.3C8.8,8.7,8.9,9,9.6,9.6 c0.7,0.5,1.1,1.1,1,2.2c-0.3,1.1-1.6,1.7-2.8,1.7c-0.9,0-2.8-0.3-2.9-1.7c0-1.3,1.9-2.1,3.2-2.1C7.8,9.3,7.7,9.1,7.9,8.5 C6.8,8.4,5.6,7.8,5.5,6.4H3.3l3.3-2.9h5.6L11.8,4v0.8C11.9,4.8,11.9,4.9,11.9,5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGschoLogo);
export default __webpack_public_path__ + "static/media/gscho-logo.e1fe64db.svg";
export { ForwardRef as ReactComponent };